import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { preventDoubleSubmit } from './submit-once';

preventDoubleSubmit();
